import styled from 'styled-components';

const accent = '#f7c315';
const surface = '#1e2430';

const KeyboardWrapper = styled.div`
  .keyboard {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    background: ${surface};
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 16px 18px;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  }

  .keyboardVisible {
    visibility: ${() => (window.localStorage.getItem('kiosk') === '1' ? 'visible' : 'hidden')};
  }

  /* Legacy terminal viewports retain keyboard access without kiosk mode. */
  @media (min-aspect-ratio: 45/40) and (max-aspect-ratio: 55/40) {
    .keyboardVisible {
      visibility: visible;
    }
  }

  .keyboard-row {
    display: flex;
    gap: 6px;
    margin-bottom: 8px;
  }

  .keyboard-row:last-child {
    margin-bottom: 0;
  }

  .keyboard-keysSet {
    display: flex;
    flex-grow: 1;
  }

  .keyboard-button {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1 0;
    min-width: 0;
    font-size: 18px;
    height: 54px;
    border-radius: 8px;
    background-color: #2b3444;
    border: 1px solid rgba(255, 255, 255, 0.08);
    font-family: 'Roboto', 'Segoe UI', sans-serif;
    font-weight: 500;
    color: #f5f7fa;
    transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
  }

  .keyboard-button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(247, 195, 21, 0.35);
  }

  .keyboard-button:disabled {
    opacity: 0.4;
    cursor: default;
  }

  .keyboard-button:not(:disabled):hover {
    background-color: #323c4f;
    border-color: rgba(247, 195, 21, 0.35);
  }

  .keyboard-button:not(:disabled):active {
    background-color: ${accent};
    border-color: ${accent};
    color: #1b1e25;
  }

  .keyboard-numberButton {
    flex-grow: 1;
  }

  .keyboard-halfButton {
    flex-basis: 60px;
  }

  .keyboard-space {
    flex-grow: 3;
  }

  .keyboard-utilButton {
    flex-grow: 1.3;
    max-width: 110px;
  }

  .keyboard-additionalButton {
    flex-basis: 128px;
  }

  .keyboard-submit-button {
    flex-basis: 110px;
    background-color: ${accent};
    border-color: ${accent};
    color: #1b1e25;
  }

  .keyboard-submit-button:not(:disabled):hover {
    background-color: #ffd74f;
    border-color: #ffd74f;
    color: #1b1e25;
  }

  .keyboard-drag-toggle {
    border-color: rgba(247, 195, 21, 0.25);
  }

  .keyboard-drag-toggle.active {
    background-color: ${accent};
    border-color: ${accent};
    color: #1b1e25;
  }

  .keyboard-drag-toggle.active:not(:disabled):hover {
    background-color: #ffd74f;
    border-color: #ffd74f;
    color: #1b1e25;
  }

  .keyboard-button.shift-symbols {
    flex-grow: 1.6;
  }

  .keyboard-wrapper {
    position: fixed;
    bottom: 20px;
    z-index: 2000000;
    width: min(960px, calc(100vw - 24px));
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  .vnc-fill {
    position: fixed;
    bottom: 20px;
    z-index: 10000;
    width: min(960px, calc(100vw - 24px));
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .keyboard-wrapper,
    .vnc-fill {
      width: calc(100% - 24px);
    }
  }

  .keyboard.keyboard-numpad-size {
    max-width: 480px;
    padding: 16px 14px;
  }

  .keyboard-numpad {
    display: flex;
    gap: 10px;
  }

  .keyboard-numpad-main {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }

  .keyboard-numpad-side {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-auto-rows: 54px;
    gap: 6px;
    width: 96px;
  }

  .keyboard-numpad-side .keyboard-button {
    width: 100%;
    height: 100%;
  }

  .keyboard-numpad-side .keyboard-submit-button {
    font-size: 16px;
    padding: 0;
  }

  .keyboard-numpad-spacer {
    visibility: hidden;
    pointer-events: none;
  }

  .keyboard-numpad-main .keyboard-button {
    width: 100%;
  }
`;

export default KeyboardWrapper;
